

import { Error } from "@progress/kendo-react-labels";
import {
    DeepMap,
    FieldError,
    UseFormRegister,
    Path,
    Controller,
    FieldValues
} from 'react-hook-form';
import { boolean } from "yup";
import DropDownListselect, {Props} from '../components/dropdown';

export type DropDownInputProps<TFormValues extends FieldValues> = {
    name: Path<TFormValues>;
    data?: any;
    onChange?: any;
    defaultValue?: any
    label?:string;
    value?:any;
    register?: UseFormRegister<TFormValues>;
    // textField?: any,
    // dataItemKey?: any,
    errors?: Partial<DeepMap<TFormValues, FieldError>>;
    control?: any;
    textField?:string;
    defaultItem?:any;
    dataItemKey?:string;
    ref?: any;
    disabled?: boolean;
} & Omit<Props, 'name'>;

export const DropDownInput = <TFormValues extends Record<string, unknown>>({
    name,
    register,
    errors,
    label,
    value,
    data,
    onChange,
    textField,
    defaultValue,
    defaultItem,
    dataItemKey,
    control,
    ref,
    disabled,
    ...props

}: DropDownInputProps<TFormValues>): JSX.Element => {
    // If the name is in a FieldArray, it will be 'fields.index.fieldName' and errors[name] won't return anything, so we are using lodash get
    //   const errorMessages = get(errors, name);
    const hasError = !!(errors);

    return (
    <div className={`form ${errors?.[name]?.message ? 'errorFiled' : ""}`} aria-live="polite">
        {label && <label className="lablel">{label}</label>}
        <Controller 
            name={name}
            control={control}
            render={({ field: { onChange, value } }) => (
                <DropDownListselect
                    //name={name}
                    data={data}
                    value={value}
                    defaultItem={defaultItem}
                    dataItemKey={dataItemKey}
                    textField={textField}
                    disabled={disabled}
                    defaultValue={defaultValue}
                    // aria-invalid={hasError}
                    // {...props}
                    {...(register && register(name, {
                        onChange: (e : any) => { onChange(e) }
                    }))}
                    ref={ref}
                />
            )}
        />
        <Error>{errors?.[name]?.message}</Error>
    </div>
    );
};
